import Konva from 'konva'

export default {
  data () {
    return {
      showNewGrouping: false,
      groupChildren: null
    }
  },

  computed: {
    creatingGroup () {
      if (this.drawLayer) {
        return this.tempLayer.find('Group').filter(function (group) {
          return group.attrs.edit_type === 'creating'
        })[0]
      }
    }
  },

  methods: {
    shapesInGroup (group) {
      let shapes = this.drawLayer.find('.crop_rect')
      let shapeNodes = []
      let groupEndPointX = group.attrs.x_pos + group.attrs.width
      let groupEndPointY = group.attrs.y_pos + group.attrs.height

      shapes.forEach(function (shape) {
        // if the shape is an orphan, check if it falls in the current group rect or not
        // else if the shape belongs to this group, push it
        if (shape.parent.nodeType === 'Layer') {
          if (shape.attrs.x_pos >= group.attrs.x_pos && shape.attrs.y_pos >= group.attrs.y_pos && shape.attrs.x_pos <= groupEndPointX && shape.attrs.y_pos <= groupEndPointY) {
            shapeNodes.push(shape)
          }
        } else if (shape.parent['_id'] === group['_id']) {
          shapeNodes.push(shape)
        }
      })

      return shapeNodes
    },

    groupsInGroup (group) {
      if (!group.attrs.x_pos) {
        group.attrs.x_pos = group.attrs.x
      }
      if (!group.attrs.y_pos) {
        group.attrs.y_pos = group.attrs.y
      }

      let groups = this.drawLayer.find('Group')
      let groupNodes = []
      let groupEndPointX = group.attrs.x_pos + group.attrs.width
      let groupEndPointY = group.attrs.y_pos + group.attrs.height

      groups.forEach(function (child) {
        if (child['_id'] !== group['_id']) {
          if (child.parent.nodeType === 'Layer') {
            if (child.attrs.x_pos >= group.attrs.x_pos && child.attrs.y_pos >= group.attrs.y_pos && child.attrs.x_pos <= groupEndPointX && child.attrs.y_pos <= groupEndPointY) {
              groupNodes.push(child)
            }
          } else if (child.parent['_id'] === group['_id']) {
            groupNodes.push(child)
          }
        }
      })

      return groupNodes
    },

    updateRequiredField (group, shape) {
      let groupType = group.attrs.dataType
      let shapeType = shape.attrs.dataType
      let required = shape.attrs.required
      if (groupType === 'single_select' || groupType === 'multi_select') {
        if (shapeType === 'checkbox') {
          required = false
        }
      }
      return required
    },

    buildPath (group) {
      let groupNodes = this.groupsInGroup(group)
      let shapeNodes = this.shapesInGroup(group)
      let groupChildren = groupNodes.concat(shapeNodes)

      groupChildren.forEach((child) => {
        let newPath = child.attrs.path.split('.').pop()
        let required = this.updateRequiredField(group, child)
        child.setAttrs({
          x: child.attrs.x_pos - group.attrs.x_pos,
          y: child.attrs.y_pos - group.attrs.y_pos,
          path: group.attrs.path + '.' + newPath,
          draggable: false,
          required: required
        })

        if (child.nodeType === 'Group') {
          this.buildPath(child)
        }

        group.add(child)
      })
    },

    createNewGroup (shape) {
      let holderShape = shape
      let parentPath = this.drawLayer.attrs.path

      let newGroup = new Konva.Group({
        x: shape.attrs.x,
        y: shape.attrs.y,
        width: shape.attrs.width,
        height: shape.attrs.height,
        draggable: true,
        id: 'new',
        edit_type: 'creating',
        name: 'group',
        path: parentPath + '.' + this.pathCount,
        template_id: shape.attrs.template_id,
        map_type: 'group',
        required: shape.attrs.required
      })

      holderShape.setAttrs({
        x: 0,
        y: 0,
        draggable: false,
        name: 'group_holder',
        map_type: 'group_holder'
      })

      this.pathCount++
      newGroup.add(holderShape)

      this.tempLayer.add(newGroup)
      this.tempLayer.draw()
    },

    groupCreated (mappingData, selectedChildren) {
      let newGroup = this.creatingGroup

      newGroup.setAttrs({
        id: 'created',
        key: mappingData.name,
        dataType: mappingData.type,
        x_pos: newGroup.attrs.x,
        y_pos: newGroup.attrs.y,
        edit_type: 'created',
        uniq_id: Date.now().toString(),
        required: mappingData.required,
        order: mappingData.order > this.updatedNoOfMappings ? this.updateOrderForGroup(selectedChildren) : mappingData.order
      })

      let groupChildren = this.groupChildren.filter(function (child) {
        return (selectedChildren.indexOf(child.attrs.uniq_id) > -1)
      })
      groupChildren.sort((a, b) => a.attrs.order - b.attrs.order)

      groupChildren.forEach((child, index) => {
        let newPath = child.attrs.path.split('.').pop()
        let required = this.updateRequiredField(newGroup, child)
        child.setAttrs({
          x: child.attrs.x_pos - newGroup.attrs.x_pos,
          y: child.attrs.y_pos - newGroup.attrs.y_pos,
          path: newGroup.attrs.path + '.' + newPath,
          draggable: false,
          required: required,
          order: index + 1
        })

        if (child.nodeType === 'Group') {
          this.buildPath(child)
        }
        newGroup.add(child)
      })

      this.drawLayer.add(newGroup)
      if (mappingData.order <= this.updatedNoOfMappings) {
        this.updateOrderForMappings(mappingData)
      }

      newGroup.draw()

      this.bindListeners(newGroup)
      this.groupChildren = null
      this.showNewGrouping = false
      this.updateMappingData()
      this.pushToHistory()
    },

    groupCancelled () {
      this.showNewMapping = false
      let invalidGroup = this.creatingGroup
      if (invalidGroup) {
        invalidGroup.destroy()
        this.tempLayer.draw()
        this.showNewGrouping = false
      }
    },

    updateOrderForGroup (selectedChildren) {
      let noOfMappings = this.updatedNoOfMappings
      let originalChildren = this.groupChildren
      if (originalChildren.length === selectedChildren.length) {
        return noOfMappings - (selectedChildren.length - 1)
      } else {
        return noOfMappings - selectedChildren.length
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/groupMappings.js